import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import * as d3 from 'd3';
declare var $: any;
@Component({
    selector: 'app-d3-chart',
    templateUrl: './d3-chart.component.html'
})
export class D3ChartComponent implements OnInit {
    @Input() Data: any;
    @Input() Rowrank: any;
    @Input() IsEdit: boolean;
    @Input() IsOverAll: boolean;
    chartType: string='';
    GraphData: any;
    constructor() { }
    // ngOnInit(): void {
    // }
    ngOnInit() {
        // let lineData = this.GraphData;
        // let chartContainer = this.chartContainer;
        if (this.IsOverAll) {
            this.chartType = this.Data[0].ChartType.trim();
            this.LoadOverAllCharts(this.Data, this.Rowrank, this.IsEdit);
        }
        else {
            if (this.Data.hasOwnProperty("forcast")) {
                this.chartType = "Forecast";
            }
            else {
                this.chartType = this.Data[Object.keys(this.Data)[0]].ChartType;
            }
            this.LoadCategorySubcategoryCharts(this.Data, this.Rowrank, this.IsEdit);
        }
        //this.cdr.detectChanges();  
    }
    LoadOverAllCharts(item, k, IsEditWindow) {
        var items = [];
        var xAxisCategories = [];
        var yAxisCategories = [];
        let ChartType = '';
        var Ticketcount = [];
        var Value = [];
        var chartContainerName = '#' + (IsEditWindow ? 'container' + k : 'container_' + k);
        var inputData = {};
        ChartType = this.chartType.toLowerCase(); //item[Object.keys(item)[0]][0]    
        if (ChartType.indexOf('tree') > -1 || ChartType.indexOf('stack') > -1 || ChartType.indexOf('heat') > -1 || ChartType.indexOf('area') > -1) {
            var value = [];
            $.each(item, function (j, Value) {
                items.push({ 'col': Value.X, 'row': Value.Y, 'data': Value.Data, 'HeaderOne': Value.HeaderOne ,'AppCount': Value.AppCount});
                Ticketcount.push({ Ticketcount: Value.Data, CategoryName: Value.CategoryName });
                value.push(Value.Value);
            });
            xAxisCategories.push(item[0].xAxisCategories);
            yAxisCategories.push(item[0].yAxisCategories);
            var newKeys = item[0].yAxisCategories.slice(0);
            inputData = { chartData: items, Ticketcount: Ticketcount, chartContainerName: chartContainerName, xAxisCategories: item[0].xAxisCategories, yAxisCategories: item[0].yAxisCategories, valueType: value[0], chartType: ChartType, newKeys: newKeys, currentGroup: 1 };
            this.GraphData = inputData;
            // if ($.isEmptyObject(chartData.filter(x => x.name == 'svg_' + inputData.chartContainerName)))
            //     chartData.push({ 'name': 'svg_' + inputData.chartContainerName, 'data': inputData });
            // else
            //     chartData.filter(x => x.name == 'svg_' + inputData.chartContainerName)[0].data = inputData;
            // if (ChartType.indexOf('heat') > -1)
            //     RenderHeatMapCharts(inputData);
            // else if (ChartType.indexOf('stacked column') > -1) {
            //     if (ChartType.indexOf('100') > -1)
            //         Render100PercentStackedColumnCharts(inputData);
            //     else
            //         RenderStackedColumnCharts(inputData);
            // }
            // else if (ChartType.indexOf('stacked bar') > -1) {
            //     if (ChartType.indexOf('100') > -1)
            //         Render100PercentStackedBarCharts(inputData);
            //     else
            //         RenderStackedBarCharts(inputData);
            // }
            // else if (ChartType.indexOf('area') > -1)
            //     RenderStackedAreaCharts(inputData);
            // else if (ChartType.indexOf('tree') > -1)
            //     RenderTreeMapCharts(inputData);
            // else
            //     RenderHeatMapCharts(inputData);
        }
        else if (ChartType.toLowerCase().indexOf('combo') > -1) {
            var chartContainerName = '#' + (IsEditWindow ? 'container' + k : 'container_' + k);
            //Data for the chart
            var comboData = [];

            for (var i = 0; i < item[0].sankeyFromdata.length; i++) {
                comboData[i] = {
                    "sankeyXData": item[0].xAxisCategories[i],
                    "sankeyY1Data": item[0].comboTicketcount[i] != undefined ? item[0].comboTicketcount[i] : 0, // Column chart values
                    "sankeyY2Data": item[0].sankeyData[i] != undefined ? item[0].sankeyData[i] : 0, //Line chart values
                    "XAxis": item[0].Value
                };
            }
            inputData = { chartData: comboData, chartContainerName: chartContainerName, chartType: ChartType };
            this.GraphData = inputData;
            // if ($.isEmptyObject(chartData.filter(x => x.name == 'svg_' + inputData.chartContainerName)))
            //     chartData.push({ 'name': 'svg_' + inputData.chartContainerName, 'data': inputData });
            // else
            //     chartData.filter(x => x.name == 'svg_' + inputData.chartContainerName)[0].data = inputData;

            //LoadComboChart(comboData, chartContainerName);
        }
        else if(ChartType.toLowerCase().indexOf('vpareto') > -1)
        {
            var lineData = [];
            chartContainerName = 'container_' + k;
            inputData = { chartData: this.Data, chartContainerName: chartContainerName, chartType: ChartType};
            this.GraphData = inputData;
        }
        else {
            //Data for the chart
            var lineData = [];
            var isPercentageChart = ChartType.indexOf('100%') > -1 ? true : false;
            for (var i = 0; i < item[0].sankeyFromdata.length; i++) {
                lineData[i] = {
                    "sankeyXData": item[0].sankeyFromdata[i],
                    "sankeyData": item[0].sankeyData[i],
                    "XAxis": item[0].Value
                };
            }
            var newKeys = item[0].xAxisCategories.slice(0);
            inputData = { chartData: lineData, chartContainerName: chartContainerName, chartType: ChartType, newKeys: newKeys, currentGroup: 1, xAxisCategories: item[0].xAxisCategories };
            this.GraphData = inputData;
            // if ($.isEmptyObject(chartData.filter(x => x.name == 'svg_' + inputData.chartContainerName)))
            //     chartData.push({ 'name': 'svg_' + inputData.chartContainerName, 'data': inputData });
            // else
            //     chartData.filter(x => x.name == 'svg_' + inputData.chartContainerName)[0].data = inputData;
            // if (ChartType.indexOf('line') > -1)
            //     LoadLineChart(lineData, chartContainerName);
            // else if (ChartType.indexOf('column') > -1) {
            //     if (!isPercentageChart)
            //         LoadColumnChart(lineData, chartContainerName);
            //     else
            //         Load100PercColumnChart(lineData, chartContainerName);
            // }
            // else if (ChartType.indexOf('bar') > -1) {
            //     if (!isPercentageChart)
            //         LoadBarChart(lineData, chartContainerName);
            //     else
            //         Load100PercBarChart(lineData, chartContainerName);
            // }
            // else
            //     RenderPieChartsWithLabel(inputData);
        }
    }
    LoadCategorySubcategoryCharts(Val, k, isChartForCategory) {
        var XAxisLabels = [];
        var TicketCountDatas = [];
        var ChartType = null;
        var xAxisCategories = [];
        var yAxisCategories = [];
        var TicketCountDatas2 = [];
        var XAxisLabels2 = [];
        var count = [];
        var Value = [];
        var inputData = {};
        var chartContainerName = '#' + (isChartForCategory ? 'container' + k : 'container_' + k);
        // var chartContainerName = '#' + ($.isNumeric(k) ? 'container_' + k : k);
        ChartType = this.chartType.toLowerCase();
        if (ChartType.indexOf("forecast") > -1) {
            let TicketCountData3 = [];
            let XAxisLabel3 = [];
            let ForcastedValue = [];
            let SplineData = [];
            if (Val.forcast != null || Val.forcast != "" || Val.forcast != undefined) {
                $.each(Val, function (key, value) {
                    TicketCountData3 = Val[key].TicketCount;
                    ForcastedValue = Val[key].ForcastedVaues;
                    XAxisLabel3 = Val[key].xAxisLabels;
                });
                XAxisLabel3.forEach((d, i) => {
                    SplineData[i] = {
                        "ActualValue": TicketCountData3[i] != undefined ? parseInt(TicketCountData3[i]) : 0,
                        "ForecastedValue": ForcastedValue[i] != undefined ? parseInt(ForcastedValue[i]) : 0,
                        "XAxis": d
                    }
                });
                inputData = { chartData: SplineData, chartContainerName: chartContainerName, chartType: ChartType };
                this.GraphData = inputData;
            }
        }
        else if (ChartType.indexOf('tree') > -1 || ChartType.indexOf('stack') > -1 || ChartType.indexOf('heat') > -1 || ChartType.indexOf('area') > -1) {
            var Ticketcount = [];
            Value.push(Object.keys(Val)[0].split(':|:')[4]);
            var x = 0; var y = 0;
            var items = [];
            $.each(Val[Object.keys(Val)[0]].xAxisCategories, function (idX, itemX) {
                y = 0;
                $.each(Val[Object.keys(Val)[0]].yAxisCategories, function (idY, itemY) { // + "_" + Convert.ToString(row["ChartType"]) + "_" + Convert.ToString(row["Value"])
                    var data = Val[itemX + ':|:' + Object.keys(Val)[0].split(':|:')[1] + ':|:' + itemY + ':|:' + Object.keys(Val)[0].split(':|:')[3] + ':|:' + Object.keys(Val)[0].split(':|:')[4]];
                    if (!$.isEmptyObject(data) && data != null) {
                        //items.push([x,y,data.y]);
                        items.push({ 'col': x, 'row': y, 'data': data.y });
                        Ticketcount.push({ Ticketcount: data.y, CategoryName: itemY });
                    }
                    else {
                        //items.push([x,y,0]);
                        items.push({ 'col': x, 'row': y, 'data': 0 });
                        Ticketcount.push({ Ticketcount: 0, CategoryName: itemY });
                    }
                    y++;
                });
                x++;
            });
            xAxisCategories.push(Val[Object.keys(Val)[0]].xAxisCategories);
            yAxisCategories.push(Val[Object.keys(Val)[0]].yAxisCategories);
            var newKeys = Val[Object.keys(Val)[0]].yAxisCategories.slice(0);
            inputData = { chartData: items, Ticketcount: Ticketcount, chartContainerName: chartContainerName, xAxisCategories: Val[Object.keys(Val)[0]].xAxisCategories, yAxisCategories: Val[Object.keys(Val)[0]].yAxisCategories, valueType: Value[0], chartType: ChartType, newKeys: newKeys, currentGroup: 1 };
            this.GraphData = inputData;
            // if ($.isEmptyObject(chartData.filter(x => x.name == 'svg_' + inputData.chartContainerName)))
            //     chartData.push({ 'name': 'svg_' + inputData.chartContainerName, 'data': inputData });
            // else
            //     chartData.filter(x => x.name == 'svg_' +  inputData.chartContainerName)[0].data = inputData;
            // if (ChartType.indexOf('heat') > -1) {
            //     RenderHeatMapCharts(inputData);
            // }
            // else if (ChartType.indexOf('stacked column') > -1) {
            //     if (ChartType.indexOf('100') > -1)
            //         Render100PercentStackedColumnCharts(inputData);
            //     else
            //         RenderStackedColumnCharts(inputData);
            // }
            // else if (ChartType.indexOf('stacked bar') > -1) {
            //     if (ChartType.indexOf('100') > -1)
            //         Render100PercentStackedBarCharts(inputData);
            //     else
            //         RenderStackedBarCharts(inputData);
            // }
            // else if (ChartType.indexOf('area') > -1)
            //     RenderStackedAreaCharts(inputData);
            // else if (ChartType.indexOf('tree') > -1)
            //     RenderTreeMapCharts(inputData);
            // else
            //     RenderHeatMapCharts(inputData);
        }
        else if (ChartType.indexOf('combo') > -1) {
            var chartContainerName = '#' + (isChartForCategory ? 'container' + k : 'container_' + k);
            // var chartContainerName = $.isNumeric(k) ? '#container_' + k : "#" + k;
            //Data for the chart
            var comboData = [];

            for (var i = 0; i < Val[Object.keys(Val)[0]].sankeyFromdata.length; i++) {
                comboData[i] = {
                    "sankeyXData": Val[Object.keys(Val)[0]].xAxisCategories[i],
                    "sankeyY1Data": Val[Object.keys(Val)[0]].yAxisCategories[i] != undefined ? Val[Object.keys(Val)[0]].yAxisCategories[i] : 0, // Column chart values
                    "sankeyY2Data": Val[Object.keys(Val)[0]].sankeyData[i] != undefined ? Val[Object.keys(Val)[0]].sankeyData[i] : 0, //Line chart values
                    "XAxis": Val[Object.keys(Val)[0]].CategoryName.split(':')[8]
                };
            }
            inputData = { chartData: comboData, chartContainerName: chartContainerName, chartType: ChartType };
            this.GraphData = inputData;
            // if ($.isEmptyObject(chartData.filter(x => x.name == 'svg_' + inputData.chartContainerName)))
            //     chartData.push({ 'name': 'svg_' + inputData.chartContainerName, 'data': inputData });
            // else
            //     chartData.filter(x => x.name == 'svg_' + inputData.chartContainerName)[0].data = inputData;
            // LoadComboChart(comboData, chartContainerName);
        }
        else {
            //Data for the chart
            var lineData = [];
            var isPercentageChart = ChartType.indexOf('100%') > -1 ? true : false;
            for (var i = 0; i < Val[Object.keys(Val)[0]].sankeyFromdata.length; i++) {
                lineData[i] = {
                    "sankeyXData": Val[Object.keys(Val)[0]].sankeyFromdata[i],
                    "sankeyData": Val[Object.keys(Val)[0]].sankeyData[i],
                    "XAxis": Val[Object.keys(Val)[0]].CategoryName.split(':')[8]
                };
            }
            var newKeys = Val[Object.keys(Val)[0]].xAxisCategories.slice(0);
            inputData = { chartData: lineData, chartContainerName: chartContainerName, chartType: ChartType, newKeys: newKeys, currentGroup: 1, xAxisCategories: Val[Object.keys(Val)[0]].xAxisCategories };
            this.GraphData = inputData;
            // if ($.isEmptyObject(chartData.filter(x => x.name == 'svg_' + inputData.chartContainerName)))
            //     chartData.push({ 'name': 'svg_' + inputData.chartContainerName, 'data': inputData });
            // else
            //     chartData.filter(x => x.name == 'svg_' + inputData.chartContainerName)[0].data = inputData;
            // if (ChartType.indexOf('line') > -1)
            //     LoadLineChart(lineData, chartContainerName);
            // else if (ChartType.indexOf('column') > -1) {
            //     if (!isPercentageChart)
            //         LoadColumnChart(lineData, chartContainerName);
            //     else
            //         Load100PercColumnChart(lineData, chartContainerName);
            // }
            // else if (ChartType.indexOf('bar') > -1) {
            //     if (!isPercentageChart)
            //         LoadBarChart(lineData, chartContainerName);
            //     else
            //         Load100PercBarChart(lineData, chartContainerName);
            // }
            // else
            //     RenderPieChartsWithLabel(inputData);
            //RenderPieChartsWithLabel(lineData, chartContainerName);
        }
    }
}
